import { useState } from 'react';
import { Translate, useTranslate } from '~/i18n';
import { ShareIcon } from '~/svgs/common';
import cn from 'classnames';
import dynamic from 'next/dynamic';
const ShareList = dynamic(() => import('../common/share'), { ssr: false });

export const DetailsShare = ({
   share_title,
   share_description,
   small,
   onShareClick,
   classNames,
}: {
   share_title?: string;
   share_description?: string;
   small?: boolean;
   onShareClick?: () => void;
   classNames?: string;
}) => {
   const [sharing, setShare] = useState(false);
   const { translate } = useTranslate();

   const share = () => {
      onShareClick?.();
      if (navigator.share) {
         navigator.share({
            url: window.location.href,
            title: share_title,
            text: share_description,
         });
      } else setShare(true);
   };

   return (
      <div className="relative">
         <button
            onClick={share}
            aria-label={translate({ id: 'common:share' })}
            className={cn(
               'flex items-center space-x-2 rtl:space-x-reverse  border justify-center rounded-lg focus:outline-none focus:bg-white hover:bg-white text-madinah-primary',
               small ? 'w-10' : 'w-[127px]',
               classNames && classNames
            )}>
            <ShareIcon className={`fill-current ${!small ? 'w-4 h-4' : 'w-5 h-5'}`} />
            {!small && (
               <span className="mt-1">
                  <Translate id="common:share" />
               </span>
            )}
         </button>
         <ShareList
            sharing={sharing}
            share_description={share_description || ''}
            share_title={share_title || ''}
            closeList={() => setShare(false)}
         />
      </div>
   );
};
